import { FileTrigger } from 'components/FileTrigger/FileTrigger'
import { Button } from 'blaze-ui/Button'
import { Upload5 } from 'blaze-ui/icons'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

interface UploadButtonProps {
  onUpload: (file: File) => void
}

export const UploadButton = ({ onUpload }: UploadButtonProps) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()

  return (
    <FileTrigger
      allowsMultiple={false}
      accept="image/*"
      onSelect={async (files) => {
        if (!files) return
        const fileList = {
          ...files,
          item: (index: number) => files[index] ?? null,
          length: files.length,
        } as FileList
        onUpload(fileList[0])
      }}
    >
      <Button
        variant={isSystemRedesignEnabled ? 'tertiary' : 'secondary'}
        size={isSystemRedesignEnabled ? 'sm' : 'xs'}
        fullWidth={!isSystemRedesignEnabled}
        frontIcon={Upload5}
      >
        Upload
      </Button>
    </FileTrigger>
  )
}
